import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faArrowRight, faInbox } from '@fortawesome/free-solid-svg-icons';

const SupportPendingLightToast = ({ toast, onOpenTicket, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (toast) {
      setIsVisible(true);
      timerRef.current = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => onDismiss(), 250);
      }, 6500);

      return () => {
        if (timerRef.current) clearTimeout(timerRef.current);
      };
    }
  }, [toast, onDismiss]);

  if (!toast) return null;

  const handleOpen = () => {
    setIsVisible(false);
    setTimeout(() => {
      onOpenTicket(toast.idTicket);
      onDismiss();
    }, 120);
  };

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onDismiss(), 200);
  };

  const handleMouseEnter = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onDismiss(), 250);
    }, 3500);
  };

  return (
    <div
      className="position-fixed bottom-0 start-0 m-3 m-md-4"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        zIndex: 99999,
        maxWidth: '315px',
        width: 'calc(100vw - 32px)',
        transform: isVisible ? 'translateY(0)' : 'translateY(18px)',
        opacity: isVisible ? 1 : 0,
        transition: 'all 0.28s cubic-bezier(0.16, 1, 0.3, 1)'
      }}
    >
      <div
        className="card border-0 shadow-sm"
        style={{
          borderRadius: '10px',
          overflow: 'hidden',
          background: 'rgba(255, 255, 255, 0.97)',
          backdropFilter: 'blur(8px)',
          borderLeft: '4px solid #0284c7',
          borderTop: '1px solid rgba(2, 132, 199, 0.15)',
          borderRight: '1px solid rgba(0, 0, 0, 0.06)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
          boxShadow: '0 6px 20px rgba(15, 23, 42, 0.12), 0 2px 4px rgba(0, 0, 0, 0.04)'
        }}
      >
        <div className="card-body p-2 px-3">
          {/* Header discreto y compacto */}
          <div className="d-flex align-items-center justify-content-between mb-1">
            <div className="d-flex align-items-center gap-1">
              <span
                className="d-inline-flex align-items-center justify-content-center text-primary"
                style={{ fontSize: '0.8rem', marginRight: '2px' }}
              >
                <FontAwesomeIcon icon={faInbox} style={{ color: '#0284c7' }} />
              </span>
              <span
                className="badge rounded-pill px-2 py-0"
                style={{
                  fontSize: '0.68rem',
                  backgroundColor: '#e0f2fe',
                  color: '#0369a1',
                  fontWeight: 600
                }}
              >
                {toast.categoriaTexto || 'Pendiente'}
              </span>
              <span className="fw-bold font-sans-serif text-secondary small ms-1" style={{ fontSize: '0.78rem' }}>
                #{toast.idTicket}
              </span>
            </div>
            <button
              type="button"
              className="btn btn-sm btn-link text-400 p-0 text-decoration-none hover-text-dark"
              onClick={handleClose}
              title="Cerrar aviso"
              style={{ fontSize: '0.75rem', lineHeight: '1' }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          {/* Cliente y acción rápida en una sola línea compacta */}
          <div className="d-flex align-items-center justify-content-between gap-2 mt-1">
            <div className="fw-semibold text-truncate text-900" style={{ fontSize: '0.82rem', maxWidth: '190px' }}>
              {toast.customerName || 'Cliente'}
            </div>
            <button
              type="button"
              className="btn btn-sm px-2 py-0 d-flex align-items-center gap-1 text-white shadow-none"
              style={{
                backgroundColor: '#0284c7',
                borderColor: '#0284c7',
                fontSize: '0.72rem',
                borderRadius: '6px',
                height: '22px',
                fontWeight: 600,
                whiteSpace: 'nowrap'
              }}
              onClick={handleOpen}
            >
              <span>Ver</span>
              <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: '0.62rem' }} />
            </button>
          </div>
          {toast.messageText && (
            <div
              className="text-truncate text-600 mt-1"
              style={{ fontSize: '0.74rem', maxWidth: '280px' }}
              title={toast.messageText}
            >
              {toast.messageText}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupportPendingLightToast;
